"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Explanation_1 = __importDefault(require("../Explanation"));
function Replacement(node) {
    var _a;
    const applicableReplacement = (_a = node.explanation.find((ex) => ex.satisfied)) === null || _a === void 0 ? void 0 : _a.consequence;
    const replacedNode = node.explanation.slice(-1)[0].consequence;
    return jsx_runtime_1.jsx(Explanation_1.default, { node: applicableReplacement || replacedNode }, void 0);
}
exports.default = Replacement;
